import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=3d4b99fb&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=3d4b99fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b99fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4b99fb')) {
      api.createRecord('3d4b99fb', component.options)
    } else {
      api.reload('3d4b99fb', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=3d4b99fb&scoped=true&", function () {
      api.rerender('3d4b99fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6AepnnsWrY6/JS/comp/PopupDialog.vue"
export default component.exports